import React, { useEffect } from 'react';
import styled from 'styled-components';
import i18next from "i18next";
import './style.scss';
import { useTranslation } from "react-i18next";
import FlagHe from './assets/he.svg';
import FlagEn from './assets/en.svg';

const LoaderOverlayWrapper = styled.div`
  width: 100%;
  background-color: #ffffff94;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const languageMap = {
    en: { label: "English", dir: "ltr", active: false },
    he: { label: "עִבְרִית", dir: "rtl", active: false },
};

export const NavbarLanguageSelector: React.FC = () => {

    //@ts-ignore
    // const isDev = process.env.NODE_ENV == "development" || document.ENV.LANG_MODE=="dev";
    const isDev = document.ENV.LANG_MODE=="dev";

    const defLang = "he";
    if (!isDev && i18next.language != defLang) {
        i18next.changeLanguage(defLang);
    }

    const { i18n } = useTranslation();

    return isDev ? (
        <div className="dropdown" id={"navbar-language-selector"}>
            <button className="navbar-dropdown-selector-btn dropdown-toggle" type="button" id="languages"
                data-bs-toggle="dropdown" aria-expanded="false">
                {i18n.language == 'he' && <img src={FlagHe}/>}
                {i18n.language == 'en' && <img src={FlagEn}/>}
            </button>
            <ul className="dropdown-menu" aria-labelledby="languages">
                {Object.keys(languageMap)?.map(item => (
                    <li key={item}><a className={"dropdown-item"} onClick={() => { i18next.changeLanguage(item); }}>{
                        // @ts-ignore
                        languageMap[item].label}</a></li>
                ))}
            </ul>
        </div>
    ) : null;
};

export default NavbarLanguageSelector;
